import './ServiceableUrls.less';
import React from 'react';
import { useNavigate } from '../../router/hooks/useNavigate';
import { Alert, Progress } from 'antd';
import { useFetchServiceableUrlsCountQuery } from './service';
import SmallSpinner from '../shared/SmallSpinner';
import { skipToken } from '@reduxjs/toolkit/query/react';
import useGetSettingsForPlan from '../../sales/hooks/useGetSettingsForPlan';
import useGetSubscription from '../../sales/hooks/useGetSubscription';

type Props = {
    selectedWebsiteGuid: string | null;
};

export default function ServiceableUrlsPercentBar({ selectedWebsiteGuid }: Props) {
    const navigate = useNavigate();

    const {
        data: serviceableUrlsCountData,
        isLoading: isLoadingServiceableUrlsCountData,
        isError: isErrorFetchingCount,
    } = useFetchServiceableUrlsCountQuery(selectedWebsiteGuid ? { w_guid: selectedWebsiteGuid } : skipToken);

    const { dp_max_urls: maximumServiceableUrls } = useGetSettingsForPlan();
    const { plan_code: userPlanCode } = useGetSubscription();

    const redirectToSubscriptionPlans = () => {
        navigate('/subscription/plans', null);
    };

    const isLoading = isLoadingServiceableUrlsCountData || !maximumServiceableUrls;
    const isError = !isLoading && isErrorFetchingCount;
    const isSuccess = !isLoading && serviceableUrlsCountData;
    const showUpgradeButton = !userPlanCode.includes('professional');

    return (
        <>
            {isLoading && <SmallSpinner />}

            {isError && (
                <Alert
                    message="An error occurred"
                    type="error"
                    showIcon
                />
            )}

            {isSuccess && (
                <>
                    <div className="serviceable-urls-percent-bar-text">
                        <div>
                            {serviceableUrlsCountData.count}/{maximumServiceableUrls}
                        </div>

                        {showUpgradeButton && <span onClick={redirectToSubscriptionPlans}>Upgrade</span>}
                    </div>
                    <Progress
                        percent={(serviceableUrlsCountData.count / maximumServiceableUrls) * 100}
                        style={{ width: '180px' }}
                        showInfo={false}
                        size="small"
                        strokeColor="#34BC6E"
                    />
                </>
            )}
        </>
    );
}
